// extracted by mini-css-extract-plugin
export default {"button":"ReturnToAppButton_button__50dyI"};